import { useContext } from "react";
import { SignUpContext } from "./context";

export function useSignUpContext() {
  return useContext(SignUpContext);
}
